import axios from 'axios';

import routes from 'app/routes';

export default {

  preparePayment: (countSessions, successCallback, errorCallback) => {
    axios
      .get(routes.api.members.wallet.preparePayment, {
        params: { sessions: countSessions },
      })
      .then((resp) => {
        successCallback(resp.data.data);
      }).catch((resp) => {
        errorCallback(resp.response.data);
      });
  },

};
